import formatCurrency from 'Shared/functions/formatCurrency'
import './Currency.scoped.scss'

export default function Currency({ amount, displayCurrency = 'USD' }) {
  if (amount === undefined) return null
  return <span className={`currency ${amount < 0 ? 'debit' : ''}`}>{formatCurrency(amount, displayCurrency)}</span>
}

